import { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, message } from "antd";
import ticketService from "../services/ticketService";
import { toast } from 'react-toastify';

const { TextArea } = Input;

const TicketTypes = () => {
  const [ticketTypes, setTicketTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingType, setEditingType] = useState(null);
  const [deletingType, setDeletingType] = useState(null);
  const [form] = Form.useForm();

  const fetchTicketTypes = async () => {
    setLoading(true);
    try {
      const typeList = await ticketService.getAllTicketTypes();
      setTicketTypes(typeList);
    } catch {
      message.error("Destek talebi tipleri alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      let response;
      if (editingType) {
        response = await ticketService.updateTicketType({ ...editingType, ...values });
      } else {
        response = await ticketService.addTicketType(values);
      }

      if (response?.Status) {
        toast.success(response?.Message || "İşlem başarılı.");
      } else {
        toast.error(response?.Message || "İşlem başarısız.");
      }

      fetchTicketTypes();
      setIsModalOpen(false);
      form.resetFields();
      setEditingType(null);
    } catch (error) {
      const msg = error?.response?.data?.Message || "İşlem sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await ticketService.deleteTicketType(id);
      if (response?.Status) {
        toast.success(response?.Message || "Silme işlemi başarılı.");
        fetchTicketTypes();
      } else {
        toast.error(response?.Message || "Silme işlemi başarısız.");
      }
    } catch (error) {
      const msg = error?.response?.data?.Message || "Silme sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  useEffect(() => {
    fetchTicketTypes();
  }, []);

  return (
    <div>
      <h2>Destek Talebi Tipleri</h2>
      <Button type="primary" onClick={() => setIsModalOpen(true)}>
        Yeni Tip Ekle
      </Button>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={ticketTypes}
        columns={[
          { title: "Ad", dataIndex: "name" },
          { title: "Açıklama", dataIndex: "description" },
          {
            title: "İşlem",
            render: (text, record) => (
              <>
                <Button
                  onClick={() => {
                    setEditingType(record);
                    form.setFieldsValue(record);
                    setIsModalOpen(true);
                  }}
                  style={{ marginRight: 8 }}
                >
                  Güncelle
                </Button>
                <Button
                  danger
                  onClick={() => {
                    setDeletingType(record);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Sil
                </Button>
              </>
            ),
          },
        ]}
      />

      {/* Ekle / Güncelle Modal */}
      <Modal
        title={editingType ? "Tip Güncelle" : "Tip Ekle"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingType(null);
          form.resetFields();
        }}
        onOk={() => form.submit()}
      >
        <Form form={form} onFinish={handleAddOrUpdate} layout="vertical">
          <Form.Item 
            name="name" 
            label="Tip Adı" 
            rules={[{ required: true, message: 'Tip adı zorunludur' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Açıklama">
            <TextArea rows={3} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Silme Onay Modalı */}
      <Modal
        title="Silme işlemini onaylıyor musunuz?"
        open={isDeleteModalOpen}
        onCancel={() => setIsDeleteModalOpen(false)}
        onOk={() => {
          if (deletingType) {
            handleDelete(deletingType.id);
            setIsDeleteModalOpen(false);
          }
        }}
        okText="Evet, Sil"
        okType="danger"
        cancelText="Vazgeç"
      >
        <p>
          "{deletingType?.name}" adlı tip silinecek. Bu işlemi onaylıyor musunuz?
        </p>
      </Modal>
    </div>
  );
};

export default TicketTypes;